import api from "@/lib/api";

export default {
  getAll(funnelId, stringFilter) {
    return api.get("/api/v1/planner/card/get-all", {
      params: { any: funnelId, stringFilter: JSON.stringify(stringFilter) },
    });
  },
  create(card) {
    return api.post("/api/v1/planner/card/create", card);
  },
  update(card) {
    return api.put("/api/v1/planner/card/update", card);
  },
  moveToStep(cardId, stepId) {
    return api.put("/api/v1/planner/card/update-step", { id: cardId, any: stepId });
  },
  updateResponsibleUser(cardId, userId) {
    return api.put("/api/v1/planner/card/responsible-user", { id: cardId, userId });
  },
  remove(id) {
    const ids = Array.isArray(id) ? id.join(",") : id;
    return api.delete("/api/v1/planner/card/delete", { params: { ids } });
  },
  getAllJobs(cardId) {
    return api.get("/api/v1/planner/card/get-all-job", { params: { genericId: cardId } });
  },
  createJob(job) {
    return api.post("/api/v1/planner/card/create-job", job);
  },
  updateJob(job) {
    return api.put("/api/v1/planner/card/update-job", job);
  },
  removeJob(id) {
    return api.post("/api/v1/planner/card/delete-job", { id });
  },
  getAllRentLinked(cardId) {
    return api.get("/api/v1/planner/card/get-all-rent-linked", { params: { any: cardId } });
  },
  getByRentId(rentId, userId) {
    return api.get("/api/v1/planner/card/get-by-rent", { params: { rentId, userId } });
  },
  addRentLinked(cardId, rentId) {
    return api.post("/api/v1/planner/card/create-rent-linked", { id: cardId, rentId });
  },
  removeRentLinked(cardId, rentId) {
    return api.post("/api/v1/planner/card/delete-rent-linked", { id: cardId, rentId });
  },
};

